(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'react-router', './useIntercom'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('react-router'), require('./useIntercom'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.react, global.reactRouter, global.useIntercom);
    global.index = mod.exports;
  }
})(this, function (exports, _extends2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _react, _reactRouter, _useIntercom) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.useIntercom = exports.Intercom = exports.IntercomAPI = undefined;
  var _extends3 = _interopRequireDefault(_extends2);
  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
  var _createClass3 = _interopRequireDefault(_createClass2);
  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
  var _inherits3 = _interopRequireDefault(_inherits2);
  var _react2 = _interopRequireDefault(_react);
  var _useIntercom2 = _interopRequireDefault(_useIntercom);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var IntercomAPI = exports.IntercomAPI = function IntercomAPI() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (window.Intercom) {
      window.Intercom.apply(null, args);
    } else {
      console.warn('No intercom instance found, make sure Intercom has been initialized.');
    }
  };
  var Intercom = exports.Intercom = function (_React$Component) {
    (0, _inherits3.default)(Intercom, _React$Component);
    function Intercom() {
      (0, _classCallCheck3.default)(this, Intercom);
      return (0, _possibleConstructorReturn3.default)(this, (Intercom.__proto__ || Object.getPrototypeOf(Intercom)).apply(this, arguments));
    }
    (0, _createClass3.default)(Intercom, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
          appId = _props.appId,
          data = _props.data,
          _props$intercom = _props.intercom,
          intercom = _props$intercom === undefined ? IntercomAPI : _props$intercom;
        intercom('boot', (0, _extends3.default)({
          app_id: appId
        }, data));
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(_ref) {
        var location = _ref.location;
        var _ref2 = location || {},
          previousURL = _ref2.pathname;
        var _ref3 = this.props.location || {},
          currentURL = _ref3.pathname;
        var _props$intercom2 = this.props.intercom,
          intercom = _props$intercom2 === undefined ? IntercomAPI : _props$intercom2;
        if (currentURL && previousURL && currentURL !== previousURL) {
          intercom('update');
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return Intercom;
  }(_react2.default.Component);
  exports.default = (0, _reactRouter.withRouter)(Intercom);
  exports.useIntercom = _useIntercom2.default;
});